export enum CamposParcelaEnum {
  ValorParcela = 0,
  NumeroParcelas = 1,
  Condicionante = 2,
  DataBasePrimeiraParcela = 3,
  Colchao = 4,
  IndiceCorrecao = 5,
  TaxaCorrecao = 6,
  CondicionanteDataBaseCorrecao = 7,
  DataBaseCorrecao = 8
}
